import { render, staticRenderFns } from "./BannerPro.vue?vue&type=template&id=0d9fbf66&"
import script from "./BannerPro.vue?vue&type=script&lang=js&"
export * from "./BannerPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports